/**
 * Created by fers on 10/11/16.
 */

// import KeenTracking from 'keen-tracking';
import config from '../../common/config';
// import { IntercomAPI } from 'react-intercom';
import * as BrowserPermission from "../BrowserPermission";
import Relay from "react-relay";
import {ROLE_ADMIN, ROLE_OWNER} from "../../common/model-api/Organisation2UserType";
import * as Permission from "../../common/util/Permission";
import {ROLE_COMPANY_ADMIN} from "../../common/util/Permission";
import {safeJSONparse} from "../../common/util/safeJSONparse";
import {FEATURE_CAN_SEE_ORGANISATIONS} from '../../common/util/FeatureFlags';

export const EVENT_PAGEVIEWS = "pageviews";
export const EVENT_CLICKS = "clicks";

const INTERESTING_EVENTS = {
	"invitations-create": true,
	"channels-create": true,
	"organisations-create": true,
	"scenario-apply": true,
	"extension-install": true,
	"authentication": true,
	"newsletter": true,
	"channel-activate-caching": true,
	"channel-add-success": true,
};

export default class EventTracker {
    static listening = false;
    static addonValues = {};

    static EVENT_PAGEVIEWS = EVENT_PAGEVIEWS;
    static EVENT_CLICKS = EVENT_CLICKS;

    static setTrackingUserId(userId: string): void {
        EventTracker.addonValues['user_id'] = userId;
//        ReactGA.ga('set', 'userId', userId);
    }

    static trackEvent(event: string, args): void {
        if (config.isProduction) {
            if (event === EVENT_PAGEVIEWS) {
                // ReactGA.pageview(args.location);
            } else if (INTERESTING_EVENTS[args.event]) {
                //IntercomAPI('trackEvent', args.event);
            }

			if (event !== EVENT_PAGEVIEWS) {
				// ReactGA.event({
				// 	category: args.type,
				// 	action: args.event || event,
				// });
			}
        }
    }

    static trackLocationChange(history) {
        // prevent double listening in the same context
        if (EventTracker.listening) {
            return;
        }

        history.listen((location) => {
            EventTracker.trackEvent(EVENT_PAGEVIEWS, {
                location: location.pathname + location.search,
                type: 'embed'
            });
        });
        EventTracker.listening = true;
    }

    static initEventTracker(user) {
        this.setTrackingUserId(user.realId);

        BrowserPermission.setPermissionObject({
            id: user.realId,
            globalPermissions: user.globalPermissions ? safeJSONparse(user.globalPermissions) : [],
            organisationPermissions: user.organisations2user && user.organisations2user.edges ? user.organisations2user.edges.map(({node}) => {
                if (node.permissions === "{}") {
                    node.permissions = "[]";
                }
                let perms = safeJSONparse(node.permissions);
                if (node.role && (node.role === ROLE_ADMIN || node.role === ROLE_OWNER || !node.role)) {
                    perms = [...(perms || []), ...Permission.roles[ROLE_COMPANY_ADMIN]];
                }

                return ({
                    id: node.id,
                    organisation_id: node.organisation_id,
                    role: node.role,
                    permissions: perms,
                });
            }) : [],
            featureFlags: [
				(user.orgs && user.orgs.edges && user.orgs.edges.length > 1 ? FEATURE_CAN_SEE_ORGANISATIONS : null),
				...(user.featureFlags ? safeJSONparse(user.featureFlags === "{}" ? "[]" : user.featureFlags) : [])
			].filter(item => !!item)
        });
    }

    static getFragment() {
        return Relay.QL`
            fragment on User {
                id,
                realId,
                globalPermissions,
                featureFlags,
				orgs: organisations(first: 2) {
					edges {
						node {
							id,
							realId
						}
					}
				},
                organisations2user(first: 10000) {
                    edges {
                        node {
                            id,
                            organisation_id,
                            role,
                            permissions,
                        }
                    }
                }
            }
        `;
    }
}
